import { TERTIARY, makeThemeColor } from '@tornado-rdk/theme';

export const filledColor = makeThemeColor(TERTIARY);

export const emptyColor = makeThemeColor(TERTIARY, 0);
